import { Suspense, useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Tabs from 'hb-builder/components/Layout/Panel/Tabs';
import { doesTabExist } from 'hb-builder/components/Layout/Panel/Tabs/utils';

const DefaultTabs = ({ children, item, tabs, tabsContent }) => {
  const initialTab = useMemo(() => tabs[0].id, [tabs, item.type]);

  return (
    <Tabs initialTab={initialTab} items={tabs}>
      {({ selectedTab }) => {
        if (!doesTabExist({ tabs: tabsContent, selectedTab })) {
          return null;
        }

        return (
          <WrapperSettings>
            <Suspense fallback={null}>{children({ selectedTab })}</Suspense>
          </WrapperSettings>
        );
      }}
    </Tabs>
  );
};

export default DefaultTabs;

const WrapperSettings = styled(Box).attrs(() => ({
  minHeight: '100%',
  pt: '10px',
  pb: 6,
}))``;
